import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles, renderBackground } from "../commonStyles.js";

export async function renderCarouselCardWidget(context, widget, parent, override = null) {
    const breakpoint = context.currentBreakpoint;

    const el = context.document.createElement("div");
    const topDiv = context.document.getElementById("html_renderer");
    el.classList.add("widget", "carousel_card_widget");

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getCarouselCardStyles(widget)
    };

    if (override){
        styles["height"] = parent.style.height;
        styles["width"] = breakpoint === "desktop" ? "1200px" : "375px";
        styles["position"] = "relative";
    }

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    if (override){
        topDiv.appendChild(el);
    }
    else{
        parent.appendChild(el);
    }

    renderBackground(context, widget, el);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return el;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, el, null);
    }

    return el;
}

function getCarouselCardStyles(widget) {
    return {
        height: "100%"
    };
}
